import { render, staticRenderFns } from "./decimalSetup.vue?vue&type=template&id=641676a2&scoped=true&"
import script from "./decimalSetup.vue?vue&type=script&lang=js&"
export * from "./decimalSetup.vue?vue&type=script&lang=js&"
import style0 from "./decimalSetup.vue?vue&type=style&index=0&id=641676a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641676a2",
  null
  
)

export default component.exports